import { getListVirtualStores } from "../data";
import ProductPage from "components/ProductPage";

function AdamicheModas() {
  const data = getListVirtualStores().filter(
    (item) => item.productId === "#L03"
  );
  return <ProductPage pageData={data} />;
}

export default AdamicheModas;
